var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"editorAnchor",style:({
        height: '100%',
        borderRadius: '2px',
        border: '1px solid gray',
    })})
}
var staticRenderFns = []

export { render, staticRenderFns }